import * as constants from './constants';
import actionTypes from './store/actionTypes';
import * as actions from './store/actions';
import * as apiKeys from './store/apiKeys';
import reducer from './store/reducer';
import * as selectors from './store/selectors';

const auth = {
  constants,
  selectors,
  actionTypes,
  apiKeys,
  actions,
  reducer,
};

export default auth;

export * as constants from './constants';
export * as selectors from './store/selectors';
export * as apiKeys from './store/apiKeys';
export * as actions from './store/actions';

export { default as actionTypes } from './store/actionTypes';
export { default as reducer } from './store/reducer';

export { default as LoginForm } from './components/organisms/LoginForm';
export type { ILoginFormValues } from './components/organisms/LoginForm';
export { default as ResetPasswordForm } from './components/organisms/ResetPasswordForm';
export type { IResetPasswordValues } from './components/organisms/ResetPasswordForm';

export { default as ForgotPasswordTemplate } from './components/templates/ForgotPassword';
export type { IForgotPasswordValues } from './components/templates/ForgotPassword';
export { default as ResetPasswordTemplate } from './components/templates/ResetPassword';
export { default as LogoutTemplate } from './components/templates/Logout';
export { default as LoginTemplate } from './components/templates/Login';

export { default as LoginPage } from './pages/Login';
export { default as LogoutPage } from './pages/Logout';
export { default as ForgotPasswordPage } from './pages/ForgotPassword';
export { default as ResetPasswordPage } from './pages/ResetPassword';
